import React, { Component } from 'react';
import { Button, Box, Dialog, DialogContent, FormControl } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import api from '../../../services/api';
import { diff } from 'deep-diff';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import ComboPadrao from 'views/Components/ComboPadrao';
import { ASIM } from 'consts';
import { validateField } from 'lib/functions';
import { getConfigField } from 'lib/configUtils';

// Definição dos estilos
const styles = theme => ({
    textField: {
        marginTop: theme.spacing(0),
        marginBottom: "0.5rem",
        marginRight: "0.5rem",
        variant: "outlined"
    },
    addButton: {
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        float: 'right',
    },
    modalContent: {
        maxHeight: '100vh', // Ajuste a altura máxima conforme necessário
        overflowY: 'auto', // Permite rolar verticalmente
        width: '50vh'
    },
    helperTextError: {
        color: 'red',
    }
});

class CentroDespesaFornecedorServicoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centrodespesafornecedorservico: {
                chavefornecserv: this.props.codFornecedorServico
            },
            centrodespesafornecedorservico_original: {},
            centrosdespesa: [],
            setores: [],
            projetos: [],
            errors: {},
            schema: {
                codcreditodebito: {
                    presence: { allowEmpty: false, message: 'Centro de receita/despesa obrigatório' },
                    length: { maximum: 10 },
                    type: 'select-one'
                },
                codsetor: {
                    presence: { allowEmpty: false, message: 'Setor obrigatório' },
                    length: { maximum: 10 },
                    type: 'select-one'
                }
            },
            isNewRecord: false,
            openAlert: false,
            messageAlert: ''
        };
    }

    async componentDidMount() {
        let id = this.props.id;
        let centrodespesafornecedorservicoData;

        const controlaprojeto = (getConfigField('controlaprojeto', 'cfg_financas') == ASIM);

        if (id > 0) {
            if (this.props.codFornecedorServico === undefined) {
                centrodespesafornecedorservicoData = this.props.centrodespesafornecedorservico;
            } else {
                const response = await api.get(`/fornecedorservico/centrocusto/${id}`);
                centrodespesafornecedorservicoData = response.data[0];
            }

            this.setState({
                centrodespesafornecedorservico: centrodespesafornecedorservicoData,
                centrodespesafornecedorservico_original: JSON.parse(JSON.stringify(centrodespesafornecedorservicoData)),
                isNewRecord: false
            });

            const centrosdespesa = await api.get(`/financas/centroreceitadespesa/listforchange/${centrodespesafornecedorservicoData.codcreditodebito}?tipoconta=A`);
            this.setState({ centrosdespesa: centrosdespesa.data });

            const setores = await api.get(`/setor/listforchange/${centrodespesafornecedorservicoData.codsetor}`);
            this.setState({ setores: setores.data });

            if (controlaprojeto) {
                const projetos = await api.get(`/financas/projeto/listforchange/${centrodespesafornecedorservicoData.codprojeto}?tipoconta=A`);
                this.setState({ projetos: projetos.data });
            }
        } else if (id === 'novo') {
            this.setState({ isNewRecord: true });

            this.setState(prevState => ({
                centrodespesafornecedorservico: {
                    ...prevState.centrodespesafornecedorservico
                }
            }));

            const centrosdespesa = await api.get(`/financas/centroreceitadespesa/active/true?tipoconta=A`);
            this.setState({ centrosdespesa: centrosdespesa.data });

            const setores = await api.get(`/setor/active/true`);
            this.setState({ setores: setores.data });

            if (controlaprojeto) {
                const projetos = await api.get(`/financas/projeto/active/true?tipoconta=A`);
                this.setState({ projetos: projetos.data });
            }
        }
    }

    handleCancel = () => {
        this.props.onClose();
    };

    OnChange = (event) => {
            const { centrodespesafornecedorservico } = this.state;
            const { name, type, value } = event.target;
            let adjustedValue = Number(value);

            this.setState(prevState => ({
                centrodespesafornecedorservico: {
                    ...prevState.centrodespesafornecedorservico,
                    [name]: adjustedValue
                },
                errors: {
                    ...prevState.errors,
                    [name]: typeof adjustedValue === 'string' && adjustedValue.trim() === ''
                }
            }));
    }

    onClickSave = () => {
        if (this.state.isNewRecord) {
            this.insereCentroDespesaFornecedorServico();
        } else {
            this.atualizaCentroDespesaFornecedorServico();
        }
    }

    insereCentroDespesaFornecedorServico = async () => {
        const { centrodespesafornecedorservico } = this.state;
        try {
            if (!(this.props.codFornecedorServico === undefined)) {
                const response = await api.post(`/fornecedorservico/centrocusto`, centrodespesafornecedorservico);
                if (response.status === 200) {
                    this.handleCancel();
                    this.props.onSave();
                }
            } else {
                this.handleCancel();
                this.props.onSave(this.state.centrodespesafornecedorservico);
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    atualizaCentroDespesaFornecedorServico = async () => {
        const { centrodespesafornecedorservico, centrodespesafornecedorservico_original } = this.state;

        const differences = diff(centrodespesafornecedorservico_original, centrodespesafornecedorservico);

        if (!differences) {
            this.handleCancel();
            return;
        }

        const centrodespesafornecedorservicoAlterado = {};
        differences.forEach(d => {
            if (d.kind === 'E' || d.kind === 'N') {
                centrodespesafornecedorservicoAlterado[d.path.join('.')] = d.rhs;
            }
        });

        try {
            if (!(this.props.codFornecedorServico === undefined)) {
                const response = await api.put(`/fornecedorservico/centrocusto/${centrodespesafornecedorservico.chave}`, centrodespesafornecedorservicoAlterado);
                if (response.status === 200) {
                    this.handleCancel();
                    this.props.onSave();
                }
            } else {
                this.handleCancel();
                this.props.onSave(this.state.centrodespesafornecedorservico);
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    validationRequiredFields = () => {
        const { centrodespesafornecedorservico } = this.state;
        const { schema } = this.state;
        let errors = {};
        const centrodespesaError = validateField('codcreditodebito', centrodespesafornecedorservico.codcreditodebito, schema);
        if (centrodespesaError) {
            errors.codcreditodebito = centrodespesaError;
        }
        const setorError = validateField('codsetor', centrodespesafornecedorservico.codsetor, schema);
        if (setorError) {
            errors.codsetor = setorError;
        }
        return errors;
    };

    handleSubmit = () => {
        let errors = this.validationRequiredFields();
        this.setState({ errors });
        if (Object.keys(errors).length === 0) {
            this.onClickSave();
        }
    };

    handleOpenAlert = (message) => {
        this.setState({ openAlert: true, messageAlert: message });
    };

    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    render() {
        const { isModal, classes } = this.props;

        const { centrodespesafornecedorservico } = this.state;
        const { centrosdespesa } = this.state;
        const { setores } = this.state;
        const { projetos } = this.state;

        const { errors } = this.state;

        // campos configurações
        const controlaprojeto = (getConfigField('controlaprojeto', 'cfg_financas') == ASIM);

        return (
            <Dialog open={isModal} onClose={this.handleCancel} maxWidth="sm">
                <DialogContent
                // className={classes.modalContent}
                >

                    <FormControl
                        fullWidth
                        variant="outlined"
                    >
                        <ComboPadrao
                            name={'codcreditodebito'}
                            label={'Centro de receita/despesa'}
                            value={centrodespesafornecedorservico.codcreditodebito}
                            onChange={this.OnChange}
                            fieldId={'codcreditodebito'}
                            listItems={centrosdespesa}
                            fieldDescription={'desccreditodebito'}
                            helperText={errors.codcreditodebito || ''}
                            error={!!errors.codcreditodebito}
                        />
                    </FormControl>

                    <br />
                    <br />

                    <FormControl
                        fullWidth
                        variant="outlined"
                    >
                        <ComboPadrao
                            name={'codsetor'}
                            label={'Setor'}
                            value={centrodespesafornecedorservico.codsetor}
                            onChange={this.OnChange}
                            fieldId={'codsetor'}
                            listItems={setores}
                            fieldDescription={'descsetor'}
                            helperText={errors.codsetor || ''}
                            error={!!errors.codsetor}
                        />
                    </FormControl>

                    <br />
                    <br />

                    {controlaprojeto && (
                        <FormControl
                            fullWidth
                            variant="outlined"
                        >
                            <ComboPadrao
                                name={'codprojeto'}
                                label={'Projeto'}
                                value={centrodespesafornecedorservico.codprojeto}
                                onChange={this.OnChange}
                                fieldId={'codprojeto'}
                                listItems={projetos}
                                fieldDescription={'descprojeto'}
                                // helperText={errors.codprojeto || ''}
                                // error={!!errors.codprojeto}
                            />
                        </FormControl>
                    )}                    

                    <br />
                    <br />

                    <Box style={{ float: 'right' }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.handleSubmit}
                            style={{ marginRight: '5px' }}
                        >
                            Salvar
                        </Button>

                        {isModal && (
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.handleCancel}
                            >
                                Cancelar
                            </Button>
                        )}
                    </Box>

                    <div>
                        <AlertInformation
                            open={this.state.openAlert}
                            handleClose={this.handleCloseAlert}
                            message={this.state.messageAlert}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

export default withStyles(styles)(CentroDespesaFornecedorServicoForm);